const DEFAULT_GAP = 1;
const DEFAULT_GRID_COLUMN_WIDTH = 360; // Used for Grid column and input / select widths
const DEFAULT_MAX_ITEM_WIDTH = 720 + DEFAULT_GAP; // Max width an item should take up

export { DEFAULT_GAP, DEFAULT_GRID_COLUMN_WIDTH, DEFAULT_MAX_ITEM_WIDTH };
//# sourceMappingURL=constants.mjs.map
